import { Component, OnInit, OnDestroy, Input } from '@angular/core';
//import 'ag-grid-enterprise/main';
import { LoopBackFilter } from '../../../sdk/models';
import { ActivityApi } from '../../../sdk/services/custom';
import { LoopBackAuth } from '../../../sdk/services/core/auth.service';
import * as _ from "lodash";
import { PlatformApp } from '../../../services/app.service';
@Component({
    selector: 'activity-scroll',
    templateUrl: './activity-scroll.component.html',
    providers: [ActivityApi],
    styleUrls: ['./activity-scroll.component.scss']
})

export class ActivityScrollComponent implements OnInit, OnDestroy {
    @Input() entityrecordid: any;
    @Input() count: any = 10;
    @Input() dataprovider: any;

    subscriptions: any = [];
    currentuser;
    dataArray = [];
    displayArray = [];
    index = 0;
    notifyOptions = PlatformApp.getNotificationOptions();
    constructor(private _ActivityApi: ActivityApi,
        private _LoopBackAuth: LoopBackAuth) {
    }

    ngOnInit(): void {
        this.currentuser = this._LoopBackAuth.getCurrentUserData();
        if (this.dataprovider) {
            var data = JSON.parse(JSON.stringify(this.dataprovider));
            this.dataArray = _.sortBy(data, 'updatedAt').reverse();
            this.addItems();
        } else {
            this.fetchEvents();
        }
    }

    addItems() {
        if (this.index < this.dataArray.length) {
            let startIndex = this.index;
            this.index += this.count;
            if (this.index > this.dataArray.length)
                this.index = this.dataArray.length;
            let endIndex = this.index;
            for (let i = startIndex; i < endIndex; ++i) {
                this.displayArray.push(this.dataArray[i]);
            }
        }
    }
    onScrollDown() {
        this.addItems();
    }

    fetchEvents() {
        let activityFilter: LoopBackFilter = <LoopBackFilter>{ where: {} };
        activityFilter.where['appId'] = this.currentuser.appId;
        if (this.entityrecordid)
            activityFilter.where['parentId'] = this.entityrecordid;

        this.subscriptions.push(
            this._ActivityApi.find(activityFilter)
                .subscribe((data) => {
                    if (data && data.length) {
                        this.dataArray = _.sortBy(data, 'updatedAt').reverse();
                        this.addItems();
                    }
                }));
    }

    ngOnDestroy() {
        for (var i = 0; i < this.subscriptions.length; i++) this.subscriptions[i].unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/activity-scroll/activity-scroll.component.ts